import React, {useId} from 'react'
import {Area, AreaChart, ResponsiveContainer, YAxis} from 'recharts'

const Sparkline = ({data, color, height = 40, filled = true, domain}) => {
    const gradientId = useId()
    const points = data.map((value) => ({value}))
    return (
        <ResponsiveContainer width="100%" height={height}>
            <AreaChart data={points} margin={{top: 4, right: 0, left: 0, bottom: 0}}>
                <defs>
                    <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor={color} stopOpacity={0.3} />
                        <stop offset="100%" stopColor={color} stopOpacity={0} />
                    </linearGradient>
                </defs>
                {domain && <YAxis hide domain={domain} />}
                <Area
                    type="monotone"
                    dataKey="value"
                    stroke={color}
                    strokeWidth={2}
                    fill={filled ? `url(#${gradientId})` : 'none'}
                    dot={false}
                    isAnimationActive={false}
                    connectNulls
                />
            </AreaChart>
        </ResponsiveContainer>
    )
}

export default Sparkline
